import styled from 'styled-components';
import { Background } from 'react-imgix';
import { StyledBackgroundImageProps } from './BackgroundImage.types';

export const StyledBackgroundImage = styled(
  Background,
)<StyledBackgroundImageProps>`
  ${(props) => props.customStyle}
`;
